'use client';

import React, { useMemo } from 'react';
import { Grid, GridItem } from '@skin-seoul/design-system';
import { getProductType, ProductStockStatus } from '@skin-seoul/service';
import ProductCard from '@/components/products/ProductCard/ProductCard';
import { useRegionCurrency, useReviewService, useProductService, getPriceProductBasicInfo, createReviewStatsMap } from '@skin-seoul/service';
const TrendingProductsList = () => {
  const {
    currency
  } = useRegionCurrency();
  const {
    useGetProductsCollections
  } = useProductService();
  const {
    useGetReviewStatistics
  } = useReviewService();
  const {
    data: productData
  } = useGetProductsCollections({
    page: 1,
    collectionName: 'About us Page Products',
    limit: 12,
    stockStatus: ProductStockStatus.instock,
    currency
  });
  const slicedProductData = productData.products.slice(0, 6);
  const {
    data: reviewStats
  } = useGetReviewStatistics({
    productIds: slicedProductData.map(product => product.productId).join(',')
  });
  const reviewStatsMap = useMemo(() => createReviewStatsMap(reviewStats), [reviewStats]);
  return <Grid alignItems="center" gridGap={{
    base: 3,
    tablet: 6,
    desktop: 6
  }} gridTemplateColumns="repeat(2, minmax(0, 1fr))" height="100%" width="100%" display={{
    tablet: 'none',
    base: 'grid'
  }} data-sentry-element="Grid" data-sentry-component="TrendingProductsList" data-sentry-source-file="TrendingProductsList.tsx">
      {slicedProductData.map(product => {
      const lowestPriceProductInfo = getPriceProductBasicInfo(product);
      const productType = getProductType(product);
      const productReviewStats = reviewStatsMap[product.productId];
      return <GridItem key={product.sku} minWidth={0}>
            <ProductCard key={product.productId} href={product.productLink} name={product.name} brand={product.brand} productImage={product.productImageUrls[0]} sku={product.sku} currency={product.currency} originalPrice={lowestPriceProductInfo.originalPrice} salePrice={lowestPriceProductInfo.salePrice} rating={productReviewStats?.averageRate} reviewCount={productReviewStats?.totalReviews} productType={productType} productId={product.productId.toString()} category={product.category} />
          </GridItem>;
    })}
    </Grid>;
};
export default TrendingProductsList;